import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {Group, Item} from '@pb/kit-component-group';

export const IpRangesSkeleton = () => (
    <div>
        <Group gap="xl" alignItems="start">
            <Item style={{width: 330}} className="pb-xs">
                <SkeletonItem width={60} height={14}/>
            </Item>
            <Item style={{width: 330}} className="pb-xs">
                <SkeletonItem width={40} height={14}/>
            </Item>
        </Group>
        <Group alignItems="start" direction="v" gap="s">
            <Group alignItems="start" direction="v" gap="xs">
                <Group gap="xl">
                    <Item style={{width: 330}}>
                        <Group justify="space-between">
                            <SkeletonItem width={130} height={32}/>
                            <Item/>
                            <SkeletonItem width={130} height={32}/>
                        </Group>
                    </Item>
                    <Item style={{width: 330}}>
                        <Group gap="m">
                            <SkeletonItem width={48} height={18}/>
                            <SkeletonItem width={48} height={18}/>
                            <SkeletonItem width={48} height={18}/>
                        </Group>
                    </Item>
                </Group>
            </Group>
            <SkeletonItem width={100} height={20}/>
        </Group>
    </div>
);
